/*
  Product page: the floating "Add to cart" bar.
  - shown once the main Add to cart button has scrolled above the top of the screen, and kept visible down to the footer
  (the page gets bottom space equal to the bar height so the bar never covers the last footer line)
  - its button presses the real Add to cart button (looked up at click time, because the theme replaces it when a variant changes)
  - the price and the button state ("Sold out", disabled) follow the main ones
*/
if (!customElements.get('joyvo-sticky-cta')) {
  customElements.define(
    'joyvo-sticky-cta',
    class JoyvoStickyCta extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-button]');
        this.price = this.querySelector('[data-sticky-price]');
        this.main = () => document.querySelector('product-info [id^="ProductSubmitButton-"]');
        this.productInfo = document.querySelector('product-info');
        if (!this.button || !this.productInfo) return;

        this.button.addEventListener('click', () => {
          const main = this.main();
          if (main && !main.disabled) main.click();
        });

        let queued = false;
        const schedule = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => { queued = false; this.update(); });
        };
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        // a new variant changes the price and may replace the main button
        new MutationObserver(schedule).observe(this.productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
        this.update();
      }

      update() {
        const main = this.main();
        if (!main) return;

        // follow the main button: label and disabled state
        const label = (main.querySelector('span') || main).textContent.trim();
        if (label && this.button.textContent !== label) this.button.textContent = label;
        this.button.disabled = main.disabled;

        // follow the price of the selected variant
        const price = this.productInfo.querySelector('[id^="price-"] .price');
        if (price && this.price) {
          const item = price.classList.contains('price--on-sale') ? price.querySelector('.price-item--sale') : price.querySelector('.price-item--regular');
          if (item && item.textContent.trim()) this.price.textContent = item.textContent.trim();
        }

        const scrolledPast = main.getBoundingClientRect().bottom < 0;
        this.toggleAttribute('data-hidden', !scrolledPast);
        document.body.style.paddingBottom = scrolledPast ? this.offsetHeight + 'px' : '';
      }
    }
  );
}
